import { render, staticRenderFns } from "./P2PLending.vue?vue&type=template&id=0a5f532e&"
import script from "./P2PLending.vue?vue&type=script&lang=js&"
export * from "./P2PLending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports